/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Starter_Pack_Pop_Up_ContentInputs */

const en_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You can purchase the Starter Pack at a special price. It includes Luminie, 30 Time Crystals, and 600 coins.`)
};

const ar_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`يمكنك شراء حزمة المبتدئين بسعر خاص. تتضمن Luminie و30 من «بلورة الزمن» و600 عملة.`)
};

const de_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Du kannst das Starterpaket zum Sonderpreis kaufen. Es enthält Luminie, 30 Time Crystals und 600 Münzen.`)
};

const es_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puedes comprar el paquete inicial a un precio especial. Incluye Luminie, 30 cristales de tiempo y 600 monedas.`)
};

const fr_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vous pouvez acheter le pack de démarrage à prix spécial. Il contient Luminie, 30 Cristaux de temps et 600 pièces.`)
};

const it_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Puoi acquistare il pacchetto iniziale a un prezzo speciale. Include Luminie, 30 Cristalli del Tempo e 600 monete.`)
};

const ja_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`スターターパックを特別価格で購入できます。Luminie、時の結晶30個、コイン600枚が含まれます。`)
};

const ko_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Luminie, 타임 크리스탈 30개, 코인 600개가 포함된 스타터 팩을 특별한 가격에 구매할 수 있어요.`)
};

const pt_br_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Você pode comprar o pacote inicial por um preço especial. Inclui Luminie, 30 Cristais do Tempo e 600 moedas.`)
};

const ru_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вы можете купить стартовый набор по специальной цене. В него входят Luminie, «Кристальное Время» × 30 и 600 монет.`)
};

const th_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`คุณสามารถซื้อแพ็กเริ่มต้นได้ในราคาพิเศษ ภายในประกอบด้วย Luminie, คริสตัลแห่งกาลเวลา 30 ชิ้น และเหรียญ 600 เหรียญ`)
};

const tr_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başlangıç Paketini özel bir fiyatla satın alabilirsin. İçeriği: Luminie, Zaman Kristalleri × 30 ve 600 jeton.`)
};

const zh_cn_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以用优惠价购买新手礼包，内含 Luminie、30 时光宝石与 600 金币。`)
};

const zh_tw_starter_pack_pop_up_content = /** @type {(inputs: Starter_Pack_Pop_Up_ContentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你可以用優惠價購買新手禮包，內含 Luminie、30 時光寶石與 600 金幣。`)
};

/**
* | output |
* | --- |
* | "You can purchase the Starter Pack at a special price. It includes Luminie, 30 Time Crystals, and 600 coins." |
*
* @param {Starter_Pack_Pop_Up_ContentInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const starter_pack_pop_up_content = /** @type {((inputs?: Starter_Pack_Pop_Up_ContentInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Starter_Pack_Pop_Up_ContentInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_starter_pack_pop_up_content(inputs)
	if (locale === "ar") return ar_starter_pack_pop_up_content(inputs)
	if (locale === "de") return de_starter_pack_pop_up_content(inputs)
	if (locale === "es") return es_starter_pack_pop_up_content(inputs)
	if (locale === "fr") return fr_starter_pack_pop_up_content(inputs)
	if (locale === "it") return it_starter_pack_pop_up_content(inputs)
	if (locale === "ja") return ja_starter_pack_pop_up_content(inputs)
	if (locale === "ko") return ko_starter_pack_pop_up_content(inputs)
	if (locale === "pt_br") return pt_br_starter_pack_pop_up_content(inputs)
	if (locale === "ru") return ru_starter_pack_pop_up_content(inputs)
	if (locale === "th") return th_starter_pack_pop_up_content(inputs)
	if (locale === "tr") return tr_starter_pack_pop_up_content(inputs)
	if (locale === "zh_cn") return zh_cn_starter_pack_pop_up_content(inputs)
	return zh_tw_starter_pack_pop_up_content(inputs)
});